import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MetaProvider } from "@/lib/AppContext";
import SnapshotsPage from "@/pages/SnapshotsPage";
import SnapshotLayout from "@/components/SnapshotLayout";
import Dashboard from "@/pages/Dashboard";
import CategoryPage from "@/pages/CategoryPage";
import AssetPage from "@/pages/AssetPage";
import ExportPage from "@/pages/ExportPage";
import { AuthGate } from "@/components/AuthGate";
import AccountPage from "@/pages/AccountPage";

function App() {
  return (
    <AuthGate>
    <MetaProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SnapshotsPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/s/:sid" element={<SnapshotLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="catalog/:type" element={<CategoryPage />} />
            <Route path="asset/:type/:id" element={<AssetPage />} />
            <Route path="export" element={<ExportPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </MetaProvider>
    </AuthGate>
  );
}

export default App;
